// src/Components/IntercomModule/IntercomComponent.js

import React, { useEffect } from 'react';
import { config } from '../../Config';
import Intercom from '@intercom/messenger-js-sdk';

const IntercomConfig = ({ userLogindata }) => {

  useEffect(() => {
    if (userLogindata) {
      Intercom({
        app_id: config.REACT_APP_INTERCOM_APP_ID,
        user_id: userLogindata.ID,
        name: userLogindata.FullName,
        email: userLogindata.Email,
        created_at: Math.floor(new Date().getTime() / 1000),  // Default to current time if not available
        company: userLogindata.OrgName // Set the OrgName as the company name
      });
    }
  }, [userLogindata]);

  return null;
};

export default IntercomConfig;
